import React, { useState } from "react";
import { Input as AntdInput } from "antd";
import trans from "../../utils";

export default function NormalInput({
	id,
	disabled,
	min,
	max,
	item,
	preview,
	readOnly,
	addData,
	activeInput,
	submitData,
	setSubmitData,
}) {
	const [value, setValue] = useState("");
	console.log("Submit", submitData);
	const currentValue = addData
		? submitData?.find((i) => i.key === item.key)?.value ?? ""
		: item?.value ?? value ?? "";
	console.log("Current Value", currentValue);
	const validate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === ""
		: item?.required?.value && value === "";
	const styleValidate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === ""
		: preview !== true && value === "" && item?.required?.value;
	return (
		<div style={{ flexGrow: 1, ...item.css }}>
			<label
				htmlFor={id}
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
				className="form-label d-flex align-items-center"
			>
				<div>{item?.title}</div>
				{item?.required?.value && currentValue === "" && (
					<div className="text-danger ms-2">*</div>
				)}
			</label>
			<AntdInput
				type={item?.inputType}
				placeholder={item?.placeholder}
				id={`fields[${item?.key}].value`}
				name={`fields[${item?.key}].value`}
				onKeyDown={(e) => {
					if (item?.inputType === "number")
						if (
							e.key === "e" ||
							e.key === "E" ||
							e.key === "+" ||
							e.key === "-"
						) {
							e.preventDefault();
						}
				}}
				onChange={(e) => {
					const newValue = e.target.value;
					setValue(newValue);

					if (addData) {
						setSubmitData((prev) => {
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: newValue,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				onBlur={() => {
					if (addData) {
						addData.setFieldTouched(`fields[${item?.key}].value`, true);
					}
				}}
				value={currentValue}
				disabled={disabled}
				style={{
					borderColor: styleValidate ? "red" : "",
				}}
				readOnly={readOnly}
			/>
			{preview !== true ? (
				<>
					{validate && (
						<div className="text-danger mt-1">
							{trans(item?.required?.validationMessage)}
						</div>
					)}
				</>
			) : (
				""
			)}
		</div>
	);
}
